import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import TextStyles from "../shared/typography.styles"

export const Container = styled.div`
  background-color: var(--tricorn-black);
  padding: 64px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 128px 0 64px 0;
  }
`

export const Spacer = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.lg}) {
    display: block;
  }
`

export const SectionTitle = styled.h2`
  ${TextStyles.mobileTextStyles.MobileHeadingTwoSemiBold}
  color: var(--dark-mode-body-grey);
  text-align: center;
  align-self: center;

  grid-column: 2 / -2;
  margin-top: 64px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f2f2f266;

  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletHeadingTwoSemiBold}
    margin-top: 48px;
    grid-column: 3 / -3;
    padding-bottom: 16px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${TextStyles.desktopTextStyles.HeadingTwoSemiBold}
    margin-top: 96px;
    padding-bottom: 32px;
  }
`

export const TitleContainer = styled.div`
  grid-column: 1 / -1;

  & h3 {
    color: var(--dark-mode-body-grey);
  } 

  margin-bottom: 48px;
  justify-self: center;

  @media (min-width: ${Breakpoints.md}) {
    margin-bottom: 64px;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 3 / -3;
    & h3 {
      font-size: 36px;
    }
    margin-bottom: 58px;
  }
`
